// Generated from packages/design-tokens/tokens.json — do not edit.

/** Gebaren (tokens.json gebaar): de + vasthouden, lang drukken op een rij,
 *  de drempel en het rubber van een veeg, en hoe lang een tik de bron van
 *  een lade blijft. */
export const GEBAAR = {
	houdMs: 450,
	langDrukMs: 500,
	veegDrempel: 0.4,
	veegRubber: 0.35,
	bronVensterMs: 1500,
} as const

/** Leestijden in ms (motion.durationMs): een toast zonder knop blijft
 *  lees, met een knop lees-handeling. Verminderde beweging maakt ze nooit
 *  korter. */
export const LEESTIJD = {
	lees: 2600,
	leesHandeling: 5200,
} as const
